function init_showownanim(from_php) {
    var config,girlName,
        main = $(".place.showownanim"),canv = main.find("#canvMain");

    function init() {
        if(typeof from_php.girl_id === "undefined") {
            return false;
        }
        girlName = $.takeGirlNameReal(from_php.girl_id).toLowerCase();
        config = $.takeGirlConf(from_php.girl_id,"girlownanim_png");

        config[from_php.anim_name]["left"] = from_php.left;
        config[from_php.anim_name]["top"] = from_php.top;
        var imagesObj={
            "1":{
                conf:{period_min:50,period_max:100},
                arr:[
                    {
                        path:_IMG_SERV+"/gfx/place/girlownanim/"+girlName+"/"+from_php.anim_name+"/anim.png",
                        conf:config[from_php.anim_name]
                    }
                ]
            }
        };


        canv.off("was_loaded").one("was_loaded",function(){
            canv.animCircleLoop("start");
        }).animCircleLoop({},imagesObj,_moduleTimeHandler);
    }
    init();
}